var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.37394",
      "ably": "static-3.44",
      "apollo-dlb": "static-3.80",
      "client-types": "static-1.441",
      "codemirror-dlb": "static-1.57801",
      "collaboration-sidebar": "static-1.56821",
      "ContentComponents": "static-2.70204",
      "ContentData": "static-1.67323",
      "ContentEditorUI": "static-2.76242",
      "ContentUtils": "static-1.67248",
      "customer-agent-datasources-lib": "static-1.6049",
      "customer-agent-discovery-components-lib": "static-1.2130",
      "customer-agent-forms": "static-1.3919",
      "data-fetching-client": "static-1.9359",
      "editor-components": "static-1.12778",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.38189",
      "foundations-assets": "static-1.4515",
      "foundations-components": "static-1.7269",
      "head-dlb": "static-1.4702",
      "hs-test-utils": "static-1.7665",
      "hub-http": "static-1.5872",
      "hub-http-shared-msw-handlers": "static-1.9178",
      "hubspot-dlb": "static-2.1773",
      "HubStyleTokens": "static-2.11104",
      "I18n": "static-7.1537",
      "InpageEditorUI": "static-1.84682",
      "jasmine-immutable": "static-1.2699",
      "jasmine-runner": "static-1.6137",
      "layout-dnd-utils": "static-1.10805",
      "personalization-lib": "static-1.6496",
      "quartz": "static-1.6559",
      "react-dlb": "static-1.69",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.65",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.5070",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.12181",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4381",
      "ui-components-test-utils": "static-1.5242",
      "ui-images": "static-2.1055",
      "ui-memberships-settings-lib": "static-1.33113",
      "video-components-external": "static-1.10212",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.8052",
      "amplitude-session-replay-browser": "static-1.53",
      "apollo-stack-hubspot": "static-3.79",
      "asset-actions-lib": "static-1.45177",
      "atom": "static-1.4757",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.26142",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.7281",
      "content-label-lib": "static-1.6445",
      "content-management-actions-lib": "static-1.26778",
      "content-management-data-lib": "static-1.4965",
      "content-management-restrictions-lib": "static-1.4774",
      "copilot-plugins": "static-1.10211",
      "copilot-toolkit": "static-1.10238",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.693",
      "cta-picker": "static-1.35560",
      "customer-data-objects": "static-1.7296",
      "customer-data-objects-ui-components": "static-1.12686",
      "customer-data-properties": "static-1.50441",
      "customer-data-property-utils": "static-1.7751",
      "customer-data-reference-ui-components": "static-1.12818",
      "customer-data-ui-utilities": "static-1.9508",
      "data-token-picker": "static-1.15860",
      "data-token-views": "static-1.15841",
      "error-messaging-js": "static-1.4871",
      "feedback-loader": "static-1.28651",
      "file-manager-components": "static-1.22549",
      "FileManagerCore": "static-1.38048",
      "FormsCommonComponents": "static-1.84945",
      "foundations-theming": "static-1.4085",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.4697",
      "growth-onboarding-confetti": "static-1.2736",
      "growth-onboarding-next-action-components": "static-1.1205",
      "growth-payments-core": "static-1.24400",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.5276",
      "hub-http-contrib": "static-1.2733",
      "hubspot-url-utils": "static-1.3825",
      "HubStyle": "static-2.11412",
      "icons": "static-2.610",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.13928",
      "integrations-lib": "static-1.15042",
      "interframe": "static-3.4474",
      "laboratory-lib": "static-3.6825",
      "layout-data-lib": "static-1.9130",
      "media-bridge-lib": "static-1.18380",
      "nav-meta": "static-1.28567",
      "object-builder-ui-client": "static-1.47607",
      "onboarding-scopes": "static-1.6128",
      "onboarding-tours": "static-1.16107",
      "onboarding-tours-client": "static-1.4321",
      "outpost": "static-1.3899",
      "page-lib": "static-1.21437",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.22623",
      "payments-post-enroll-local-storage-lib": "static-1.4774",
      "pictos": "static-7.177",
      "PortalIdParser": "static-2.334",
      "products-ui-components": "static-1.39018",
      "property-translator": "static-1.5098",
      "quick-fetch": "static-1.3622",
      "raven": "static-3.5564",
      "react": "static-7.175",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9898",
      "react-dom": "static-7.85",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.16316",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.54311",
      "react-virtualized": "static-2.92",
      "redux": "static-4.16",
      "redux-request-state": "static-1.10332",
      "reference-resolvers": "static-1.7844",
      "reference-resolvers-lite": "static-1.7776",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.19264",
      "rpc-client-utils": "static-1.4289",
      "sanitize": "static-1.4160",
      "sanitize-text": "static-1.7826",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9910",
      "SharedI18nStrings": "static-1.179",
      "SharedLegalStrings": "static-1.1453",
      "simple-menus-core": "static-1.14628",
      "simple-menus-lib": "static-1.16145",
      "smart-content-lib": "static-1.42223",
      "styled-components": "static-2.83",
      "StyleGuideUI": "static-3.481",
      "superstore": "static-1.4455",
      "theme-previewer-lib": "static-1.52431",
      "tinymce-config": "static-2.53437",
      "tinymce-copilot": "static-1.15505",
      "tinymce-data": "static-1.39522",
      "tinymce-plugins": "static-1.56551",
      "tinymce-themes": "static-1.55407",
      "transmute": "static-2.77",
      "ui-addon-emoji-picker": "static-1.9575",
      "ui-addon-form-validation": "static-1.10681",
      "ui-addon-i18n": "static-1.10811",
      "ui-addon-iframeable": "static-1.8698",
      "ui-addon-opt": "static-4.8074",
      "ui-addon-sales-email": "static-1.4899",
      "ui-addon-upgrades": "static-9.17394",
      "ui-business-units-lib": "static-1.8701",
      "ui-gdpr-components": "static-1.10031",
      "ui-product-approvals": "static-1.27052",
      "ui-shepherd-react": "static-3.9826",
      "ui-suspension-banners-lib": "static-1.6070",
      "UIComponents": "static-3.8051",
      "underscore": "static-1.8",
      "urlinator": "static-1.4215",
      "usage-tracker": "static-1.7020",
      "usage-tracker-core": "static-1.6870",
      "usage-tracker-session-replay": "static-1.4706",
      "user-context": "static-1.4774",
      "video-embed": "static-1.34704",
      "web-interactives-components": "static-1.13225",
      "web-interactives-data": "static-1.13226",
      "wootric-nps": "static-1.6627",
      "xray-recommendation-lib": "static-1.7417",
      "codemirror": "static-5.88",
      "react-codemirror": "static-1.10288",
      "enviro": "static-4.371",
      "hs-promise-rejection-tracking": "static-1.5234",
      "raven-hubspot": "static-1.5871",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9296",
      "bend-plugin-trellis-migration": "static-1.3120",
      "moment": "static-3.26",
      "chatspot-widget-iframe": "static-1.19860",
      "collaboration-sidebar-common": "static-1.1618",
      "framework-data-schema-resolvers": "static-1.6549",
      "frontend-preferences-client": "static-1.7608",
      "magpie-lib": "static-1.5259",
      "quartz-config": "static-1.337",
      "quartz-core": "static-1.5778",
      "advanced-menus-core": "static-1.14629",
      "advanced-menus-lib": "static-1.11624",
      "avatar-components": "static-1.2146",
      "cms-field-types": "static-1.4489",
      "content-embed-lib": "static-1.7023",
      "ExportDialog": "static-6.10072",
      "forms-utils-lib": "static-1.11949",
      "integrations-error-boundary-lib": "static-1.12457",
      "payments-embed-points-lib": "static-1.12338",
      "products-iframe-lib": "static-1.7041",
      "react-dnd-compat": "static-1.4309",
      "ui-addon-draggable-compat": "static-2.3939",
      "usage-tracker-container": "static-1.7010",
      "video-data-lib": "static-1.33870",
      "videoconference-integration-components": "static-1.6360",
      "graphql": "static-1.75",
      "backbone": "static-1.6",
      "editor-iframe-lib": "static-1.7970",
      "FireAlarmUi": "static-1.4220",
      "hubspot-apollo-client": "static-1.4565",
      "layout-dnd-components": "static-1.11830",
      "marketing-email-service-types": "static-1.1741",
      "react-transition-group": "static-1.7",
      "smart-content-core": "static-1.41570",
      "social-composer-lib": "static-1.57685",
      "structured-content-lib": "static-1.24330",
      "timezone-utils": "static-2.4930",
      "ui-addon-video-player": "static-1.8406",
      "ui-asset-management-lib": "static-1.10539",
      "ui-brand-identity-lib": "static-1.13381",
      "ui-tool-access": "static-1.9823",
      "content-icons-ui": "static-1.2110",
      "conversations-skeleton-state": "static-1.6936",
      "final-form": "static-1.63",
      "hubspot-prosemirror": "static-1.17295",
      "prosemirror": "static-1.13",
      "foundations-theming-specialty": "static-1.1801",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.59",
      "audio-components": "static-1.5446",
      "FileManagerImages": "static-1.35700",
      "quartz-i18n": "static-1.234",
      "video-components": "static-1.12215",
      "bend-plugin-foundations-components": "static-1.3538",
      "floating-ui": "static-1.49",
      "framer-motion": "static-1.64",
      "hs-story-utils": "static-1.9113",
      "tanstack-table": "static-1.48",
      "trellis-assets": "static-1.951",
      "ui-fonts": "static-1.366",
      "HeadJS": "static-2.686",
      "hs-test-utils-bend-plugin": "static-1.2776",
      "msw": "static-1.39",
      "testing-library": "static-1.145",
      "ts-schema": "static-1.3798",
      "i18n-data": "static-1.214",
      "moment-timezone": "static-5.76",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.8795",
      "react-dnd-ipeui-backend": "static-1.1666",
      "ui-coaching-tips": "static-1.27625",
      "jasmine": "static-4.4015",
      "marketplace-embed": "static-1.21180",
      "ui-addon-react-router-dom": "static-1.9230",
      "flux-actions": "static-1.294",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10059",
      "rxjs": "static-5.10",
      "react-flip-move": "static-1.63",
      "foundations-components-test-utils": "static-1.4752",
      "apollo-link-hub-http": "static-2.4334",
      "content-media-composition-data-lib": "static-1.10957",
      "content-media-compositions": "static-2.14964",
      "idb-keyval": "static-1.37",
      "immerable": "static-1.3842",
      "magpie-types": "static-1.4719",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.19868",
      "foundations-theming-base": "static-1.3070",
      "sassPrefix": "static-1.149",
      "marketing-platform-lib": "static-1.6514",
      "attribution-lib": "static-1.41404",
      "crm-message-bus": "static-1.42046",
      "crm-pipelines-api-client-types": "static-1.3858",
      "nudge-client-utils": "static-1.2002",
      "nudge-custom-ui-functions": "static-1.499",
      "reporting-enablement": "static-1.21690",
      "reporting-ui-components": "static-2.63269",
      "hubspotter-http": "static-1.4372",
      "ai-rendering-library": "static-1.8951",
      "simple-logging-lib": "static-1.2736",
      "inbound-db-properties-service-client": "static-1.3571",
      "calling-global-api": "static-1.63254",
      "calling-internal-common": "static-1.30974",
      "calling-lifecycle-internal": "static-1.64636",
      "calling-lifecycle-messages": "static-1.56930",
      "commerce-products-lib": "static-1.8499",
      "conditional-properties-service-client": "static-1.3515",
      "crm-links": "static-1.5933",
      "external-options-client-types": "static-1.3876",
      "google-libphonenumber": "static-1.31",
      "hs-entities": "static-1.334",
      "inbound-db-meta-service-client": "static-1.3352",
      "inbounddb-objects-service-types": "static-1.3943",
      "meetings-icalendar-utils-lib": "static-1.319",
      "multi-currency-client-types": "static-1.3415",
      "pipeline-validation-client-types": "static-1.3679",
      "property-value-citations": "static-1.1055",
      "pulse": "static-1.168",
      "smart-property-lib": "static-1.5465",
      "tiered-pricing": "static-1.644",
      "react-immutable-render-mixin": "static-1.9",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.518",
      "ui-universal-auth": "static-1.8539",
      "forms-ai-lib": "static-1.3807",
      "bend-plugin-foundations-theming": "static-1.2568",
      "stylex": "static-1.25",
      "embedded-academy-lib": "static-1.13192",
      "growth-onboarding-feedback-components": "static-1.6271",
      "commerce-analytics-service-client": "static-1.3367",
      "integrations-tracking-lib": "static-1.5269",
      "native-integrations-shared-strings": "static-1.7472",
      "getting-started-shared-tasks": "static-1.17545",
      "growth-data-modal": "static-1.5015",
      "growth-onboarding-next-action-utils": "static-1.1177",
      "navigation-components": "static-1.16930",
      "onboarding-tours-utils": "static-1.173",
      "ui-shepherd-tracker": "static-1.7207",
      "commerce-tours-lib": "static-1.5540",
      "growth-onboarding-reliability": "static-1.4773",
      "sales-checkout-service-client": "static-1.3379",
      "commerce-permissions": "static-1.434",
      "commerce-shared-components-lib": "static-1.17594",
      "commerce-subscription-lib": "static-1.36198",
      "crm_components": "static-3.90866",
      "crm_data": "static-4.90866",
      "customer-data-filters-ui": "static-1.38471",
      "customer-data-tracking": "static-1.6546",
      "dispatcher": "static-1.129",
      "framework-data-table": "static-2.11157",
      "property-description-translator": "static-1.3544",
      "quartz-head": "static-1.224",
      "quartz-test": "static-1.234",
      "csstype": "static-1.50",
      "batch-promise": "static-1.1213",
      "merchandise-lib": "static-1.253",
      "commerce-tools-ui-lib": "static-1.9525",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "navigation-messaging": "static-1.6257",
      "feature-store-service-types": "static-1.4213",
      "purchase-motions-components": "static-1.5310",
      "upgrade-management-service-types": "static-1.4204",
      "getting-started-shared-tasks-store": "static-1.16663",
      "seo-tools-lib": "static-1.6101",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "bender-build-tools": "static-1.2798",
      "zustand": "static-1.51",
      "framework-builder-read-service-client": "static-1.3740",
      "framework-data-schema-quick-fetch": "static-1.6454",
      "persist-promise": "static-1.3370",
      "hub-http-janus": "static-1.766",
      "reactive-lib": "static-1.412",
      "general-store": "static-6.20",
      "mobile-manifest-mixins": "static-1.460",
      "quartz-auth": "static-1.234",
      "payments-enrollment-embed-lib": "static-1.21555",
      "hubspot-apollo-cache": "static-1.24",
      "knowledge-content-types": "static-1.8266",
      "social-insights-client-types": "static-1.21062",
      "connections-embed-lib": "static-1.450",
      "marketplace-ui-client-types": "static-1.16067",
      "marketplace-ui-common": "static-1.18660",
      "marketplace-ui-details": "static-1.8556",
      "marketplace-ui-tracking": "static-1.12831",
      "property-management-iframe": "static-1.11864",
      "trellis-ecosystem": "static-1.6512",
      "hls.js": "static-1.32",
      "js-cookie": "static-1.18",
      "chatspot-client-types": "static-1.10322",
      "markdown-it": "static-1.6",
      "FormUrlGenerator": "static-2.4416",
      "highcharts": "static-8.97",
      "report-customization-components": "static-1.12191",
      "reporting-action-components": "static-1.40393",
      "reporting-data": "static-1.65996",
      "reporting-snowflake": "static-1.54615",
      "reporting-visualizations": "static-1.58073",
      "nudge-custom-function-registry": "static-1.1758",
      "nudge-renderer-utils": "static-1.2077",
      "whisper-core-api": "static-1.5672",
      "reporting-insights-lib": "static-1.836",
      "data-quality-ui-library": "static-1.12062",
      "html-to-image": "static-1.47",
      "reporting-plugins": "static-1.9835",
      "reporting-reports": "static-1.65675",
      "ui-addon-teams": "static-1.21067",
      "highlight.js": "static-1.72",
      "calling-error-reporting": "static-1.30980",
      "shared-worker-versioning": "static-1.10702",
      "calling-usage-tracker": "static-1.6224",
      "calling-orchestration-shared-library": "static-1.34451",
      "products-ui-components-shared-msw-handlers": "static-1.9560",
      "location-customization-utils-lib": "static-1.8191",
      "directed-graph": "static-1.621",
      "event-emitter": "static-1.610",
      "breeze-intelligence-kit": "static-1.5148",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9261",
      "fsm": "static-1.3416",
      "policy-lib": "static-1.6487",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9324",
      "academy-common-lib": "static-1.12652",
      "universal-page-editor-lib": "static-1.2682",
      "customer-data-associations": "static-1.7020",
      "commerce-billing-lib": "static-1.18172",
      "crm_universal": "static-1.21473",
      "customer-data-content": "static-1.26640",
      "crm_schema": "static-3.90905",
      "customer-data-email": "static-1.17482",
      "customer-data-filters-ui-msw-helpers": "static-1.20905",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.649",
      "reporting-datasets-permissions-lib": "static-1.12667",
      "deal-intel-decorators": "static-1.889",
      "tanstack-virtual": "static-1.23",
      "customer-data-rte": "static-1.32194",
      "cv-backend-services": "static-1.1446",
      "growth-onboarding-empty-states": "static-1.5199",
      "qrcode-generator": "static-1.62",
      "quotes-client-types": "static-1.36799",
      "trials-service-types": "static-1.3621",
      "growth-monetization-service-types": "static-1.4220",
      "nav-client-types": "static-1.2017",
      "purchase-motions-api": "static-1.5313",
      "signup-constants": "static-1.18172",
      "signup-ui-url-generator": "static-2.7712",
      "hubspotter-http-shared-msw-handlers": "static-1.9176",
      "marketplace-ui-apps-core": "static-1.17193",
      "stripe-embedded-components": "static-1.6936",
      "ai-settings-ui-library": "static-1.7181",
      "immutable-less": "static-1.4336",
      "react-window": "static-1.13",
      "ai-studio-lib": "static-1.10691",
      "developer-experience-shared-components": "static-1.10134",
      "marketplace-ui-reviews": "static-1.18616",
      "ui-addon-integrations-directory-panel": "static-2.7667",
      "usage-based-billing-components-lib": "static-1.7717",
      "property-management-common": "static-1.4151",
      "storybook-react": "static-1.26",
      "trellis-story-utils": "static-1.4208",
      "dashboard-lib": "static-1.80160",
      "hubspot-prosemirror-plugins": "static-1.17287",
      "share-with-third-party-component-lib": "static-1.8372",
      "reporting-client-types": "static-1.2350",
      "campaign-roi-lib": "static-1.7926",
      "calling-orchestration-schema": "static-1.34676",
      "sales-views-client-types": "static-1.3978",
      "crm-record-cards-service-types": "static-1.3345",
      "academy-service-client": "static-1.3339",
      "utility-belt": "static-1.2227",
      "SalesContentIndexUI": "static-3.8725",
      "sequences-lib": "static-1.7509",
      "deal-intel-utils": "static-1.893",
      "draft-content-plugins": "static-1.27464",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.21102",
      "eligibility-engine-service-types": "static-1.2902",
      "ui-extensibility-client-types": "static-1.3639",
      "stripe-connect-js": "static-1.62",
      "knowledge-box": "static-1.6789",
      "apps-service-types": "static-1.3562",
      "oauth-service-types": "static-1.3926",
      "platform-infra-nav-components": "static-1.7383",
      "subscription-experience-data-types": "static-1.14430",
      "crm-component-utils": "static-1.38177",
      "crm-properties-common-lib": "static-1.5555",
      "redux-actions": "static-3.7",
      "EmailSignatureEditor": "static-1.23717",
      "viral-links-lib": "static-1.6702",
      "sales-templates-service-types-lib": "static-1.3887",
      "sequences-client-types-lib": "static-1.7366",
      "edison-service-client-types": "static-1.72",
      "card-properties-lib": "static-1.43202",
      "crm-actions": "static-1.5955",
      "crm-cards-data": "static-1.1042",
      "crm-cards-sdk": "static-1.42571",
      "customer-data-properties-shared-msw-handlers": "static-1.8505",
      "sales-email-signature-service-client": "static-1.3525",
      "customer-data-sidebar": "static-2.45120",
      "enrichment-properties-lib": "static-1.14583",
      "crm-fe-perf": "static-1.22566",
      "card-payment-highlight-lib": "static-1.36201",
      "card-subscription-highlight-lib": "static-1.38621",
      "commerce-contract-lib": "static-1.10734",
      "invoices-highlight-card-lib": "static-1.53638",
      "orders-highlight-card-lib": "static-1.20600",
      "products-highlight-card-lib": "static-1.16783",
      "project-storage": "static-1.4418",
      "quotes-highlight-card-lib": "static-1.70712",
      "crm-source-interpretation-lib": "static-1.5016",
      "quotes-ui-lib": "static-1.79430",
      "accounting-integrations-ui-components": "static-1.6523",
      "invoices-ui-lib": "static-1.53654",
      "commerce-products-api": "static-1.1779",
      "SafeStorage": "static-1.4085",
      "invoices-iframe-lib": "static-1.55712",
      "quotes-modal-lib": "static-1.101387",
      "totals-ui-components": "static-1.22689",
      "commerce-totals-service-types": "static-1.3534"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.37394",
      "ably": "/ably/static-3.44",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "client-types": "/client-types/static-1.441",
      "codemirror-dlb": "/codemirror-dlb/static-1.57801",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56821",
      "ContentComponents": "/ContentComponents/static-2.70204",
      "ContentData": "/ContentData/static-1.67323",
      "ContentEditorUI": "/ContentEditorUI/static-2.76242",
      "ContentUtils": "/ContentUtils/static-1.67248",
      "customer-agent-datasources-lib": "/customer-agent-datasources-lib/static-1.6049",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2130",
      "customer-agent-forms": "/customer-agent-forms/static-1.3919",
      "data-fetching-client": "/data-fetching-client/static-1.9359",
      "editor-components": "/editor-components/static-1.12778",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.38189",
      "foundations-assets": "/foundations-assets/static-1.4515",
      "foundations-components": "/foundations-components/static-1.7269",
      "head-dlb": "/head-dlb/static-1.4702",
      "hs-test-utils": "/hs-test-utils/static-1.7665",
      "hub-http": "/hub-http/static-1.5872",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9178",
      "hubspot-dlb": "/hubspot-dlb/static-2.1773",
      "HubStyleTokens": "/HubStyleTokens/static-2.11104",
      "I18n": "/I18n/static-7.1537",
      "InpageEditorUI": "/InpageEditorUI/static-1.84682",
      "jasmine-immutable": "/jasmine-immutable/static-1.2699",
      "jasmine-runner": "/jasmine-runner/static-1.6137",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10805",
      "personalization-lib": "/personalization-lib/static-1.6496",
      "quartz": "/quartz/static-1.6559",
      "react-dlb": "/react-dlb/static-1.69",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.65",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.5070",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.12181",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4381",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5242",
      "ui-images": "/ui-images/static-2.1055",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33113",
      "video-components-external": "/video-components-external/static-1.10212",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8052",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
      "asset-actions-lib": "/asset-actions-lib/static-1.45177",
      "atom": "/atom/static-1.4757",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.26142",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.7281",
      "content-label-lib": "/content-label-lib/static-1.6445",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.26778",
      "content-management-data-lib": "/content-management-data-lib/static-1.4965",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.4774",
      "copilot-plugins": "/copilot-plugins/static-1.10211",
      "copilot-toolkit": "/copilot-toolkit/static-1.10238",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.693",
      "cta-picker": "/cta-picker/static-1.35560",
      "customer-data-objects": "/customer-data-objects/static-1.7296",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12686",
      "customer-data-properties": "/customer-data-properties/static-1.50441",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7751",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12818",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9508",
      "data-token-picker": "/data-token-picker/static-1.15860",
      "data-token-views": "/data-token-views/static-1.15841",
      "error-messaging-js": "/error-messaging-js/static-1.4871",
      "feedback-loader": "/feedback-loader/static-1.28651",
      "file-manager-components": "/file-manager-components/static-1.22549",
      "FileManagerCore": "/FileManagerCore/static-1.38048",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.84945",
      "foundations-theming": "/foundations-theming/static-1.4085",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.4697",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2736",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1205",
      "growth-payments-core": "/growth-payments-core/static-1.24400",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.5276",
      "hub-http-contrib": "/hub-http-contrib/static-1.2733",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
      "HubStyle": "/HubStyle/static-2.11412",
      "icons": "/icons/static-2.610",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13928",
      "integrations-lib": "/integrations-lib/static-1.15042",
      "interframe": "/interframe/static-3.4474",
      "laboratory-lib": "/laboratory-lib/static-3.6825",
      "layout-data-lib": "/layout-data-lib/static-1.9130",
      "media-bridge-lib": "/media-bridge-lib/static-1.18380",
      "nav-meta": "/nav-meta/static-1.28567",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47607",
      "onboarding-scopes": "/onboarding-scopes/static-1.6128",
      "onboarding-tours": "/onboarding-tours/static-1.16107",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4321",
      "outpost": "/outpost/static-1.3899",
      "page-lib": "/page-lib/static-1.21437",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.22623",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4774",
      "pictos": "/pictos/static-7.177",
      "PortalIdParser": "/PortalIdParser/static-2.334",
      "products-ui-components": "/products-ui-components/static-1.39018",
      "property-translator": "/property-translator/static-1.5098",
      "quick-fetch": "/quick-fetch/static-1.3622",
      "raven": "/raven/static-3.5564",
      "react": "/react/static-7.175",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9898",
      "react-dom": "/react-dom/static-7.85",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.16316",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.54311",
      "react-virtualized": "/react-virtualized/static-2.92",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.10332",
      "reference-resolvers": "/reference-resolvers/static-1.7844",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7776",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.19264",
      "rpc-client-utils": "/rpc-client-utils/static-1.4289",
      "sanitize": "/sanitize/static-1.4160",
      "sanitize-text": "/sanitize-text/static-1.7826",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9910",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1453",
      "simple-menus-core": "/simple-menus-core/static-1.14628",
      "simple-menus-lib": "/simple-menus-lib/static-1.16145",
      "smart-content-lib": "/smart-content-lib/static-1.42223",
      "styled-components": "/styled-components/static-2.83",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "superstore": "/superstore/static-1.4455",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.52431",
      "tinymce-config": "/tinymce-config/static-2.53437",
      "tinymce-copilot": "/tinymce-copilot/static-1.15505",
      "tinymce-data": "/tinymce-data/static-1.39522",
      "tinymce-plugins": "/tinymce-plugins/static-1.56551",
      "tinymce-themes": "/tinymce-themes/static-1.55407",
      "transmute": "/transmute/static-2.77",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9575",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10681",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10811",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8698",
      "ui-addon-opt": "/ui-addon-opt/static-4.8074",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4899",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17394",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8701",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10031",
      "ui-product-approvals": "/ui-product-approvals/static-1.27052",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9826",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.6070",
      "UIComponents": "/UIComponents/static-3.8051",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.4215",
      "usage-tracker": "/usage-tracker/static-1.7020",
      "usage-tracker-core": "/usage-tracker-core/static-1.6870",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4706",
      "user-context": "/user-context/static-1.4774",
      "video-embed": "/video-embed/static-1.34704",
      "web-interactives-components": "/web-interactives-components/static-1.13225",
      "web-interactives-data": "/web-interactives-data/static-1.13226",
      "wootric-nps": "/wootric-nps/static-1.6627",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7417",
      "codemirror": "/codemirror/static-5.88",
      "react-codemirror": "/react-codemirror/static-1.10288",
      "enviro": "/enviro/static-4.371",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
      "raven-hubspot": "/raven-hubspot/static-1.5871",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9296",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3120",
      "moment": "/moment/static-3.26",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19860",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1618",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6549",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7608",
      "magpie-lib": "/magpie-lib/static-1.5259",
      "quartz-config": "/quartz-config/static-1.337",
      "quartz-core": "/quartz-core/static-1.5778",
      "advanced-menus-core": "/advanced-menus-core/static-1.14629",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11624",
      "avatar-components": "/avatar-components/static-1.2146",
      "cms-field-types": "/cms-field-types/static-1.4489",
      "content-embed-lib": "/content-embed-lib/static-1.7023",
      "ExportDialog": "/ExportDialog/static-6.10072",
      "forms-utils-lib": "/forms-utils-lib/static-1.11949",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12457",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12338",
      "products-iframe-lib": "/products-iframe-lib/static-1.7041",
      "react-dnd-compat": "/react-dnd-compat/static-1.4309",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3939",
      "usage-tracker-container": "/usage-tracker-container/static-1.7010",
      "video-data-lib": "/video-data-lib/static-1.33870",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.6360",
      "graphql": "/graphql/static-1.75",
      "backbone": "/backbone/static-1.6",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7970",
      "FireAlarmUi": "/FireAlarmUi/static-1.4220",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4565",
      "layout-dnd-components": "/layout-dnd-components/static-1.11830",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1741",
      "react-transition-group": "/react-transition-group/static-1.7",
      "smart-content-core": "/smart-content-core/static-1.41570",
      "social-composer-lib": "/social-composer-lib/static-1.57685",
      "structured-content-lib": "/structured-content-lib/static-1.24330",
      "timezone-utils": "/timezone-utils/static-2.4930",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8406",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10539",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13381",
      "ui-tool-access": "/ui-tool-access/static-1.9823",
      "content-icons-ui": "/content-icons-ui/static-1.2110",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6936",
      "final-form": "/final-form/static-1.63",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17295",
      "prosemirror": "/prosemirror/static-1.13",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1801",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.59",
      "audio-components": "/audio-components/static-1.5446",
      "FileManagerImages": "/FileManagerImages/static-1.35700",
      "quartz-i18n": "/quartz-i18n/static-1.234",
      "video-components": "/video-components/static-1.12215",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3538",
      "floating-ui": "/floating-ui/static-1.49",
      "framer-motion": "/framer-motion/static-1.64",
      "hs-story-utils": "/hs-story-utils/static-1.9113",
      "tanstack-table": "/tanstack-table/static-1.48",
      "trellis-assets": "/trellis-assets/static-1.951",
      "ui-fonts": "/ui-fonts/static-1.366",
      "HeadJS": "/HeadJS/static-2.686",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2776",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.145",
      "ts-schema": "/ts-schema/static-1.3798",
      "i18n-data": "/i18n-data/static-1.214",
      "moment-timezone": "/moment-timezone/static-5.76",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8795",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.1666",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27625",
      "jasmine": "/jasmine/static-4.4015",
      "marketplace-embed": "/marketplace-embed/static-1.21180",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9230",
      "flux-actions": "/flux-actions/static-1.294",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10059",
      "rxjs": "/rxjs/static-5.10",
      "react-flip-move": "/react-flip-move/static-1.63",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4752",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4334",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10957",
      "content-media-compositions": "/content-media-compositions/static-2.14964",
      "idb-keyval": "/idb-keyval/static-1.37",
      "immerable": "/immerable/static-1.3842",
      "magpie-types": "/magpie-types/static-1.4719",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.19868",
      "foundations-theming-base": "/foundations-theming-base/static-1.3070",
      "sassPrefix": "/sassPrefix/static-1.149",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6514",
      "attribution-lib": "/attribution-lib/static-1.41404",
      "crm-message-bus": "/crm-message-bus/static-1.42046",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3858",
      "nudge-client-utils": "/nudge-client-utils/static-1.2002",
      "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.499",
      "reporting-enablement": "/reporting-enablement/static-1.21690",
      "reporting-ui-components": "/reporting-ui-components/static-2.63269",
      "hubspotter-http": "/hubspotter-http/static-1.4372",
      "ai-rendering-library": "/ai-rendering-library/static-1.8951",
      "simple-logging-lib": "/simple-logging-lib/static-1.2736",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3571",
      "calling-global-api": "/calling-global-api/static-1.63254",
      "calling-internal-common": "/calling-internal-common/static-1.30974",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64636",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56930",
      "commerce-products-lib": "/commerce-products-lib/static-1.8499",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3515",
      "crm-links": "/crm-links/static-1.5933",
      "external-options-client-types": "/external-options-client-types/static-1.3876",
      "google-libphonenumber": "/google-libphonenumber/static-1.31",
      "hs-entities": "/hs-entities/static-1.334",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3352",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3943",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.319",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3415",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3679",
      "property-value-citations": "/property-value-citations/static-1.1055",
      "pulse": "/pulse/static-1.168",
      "smart-property-lib": "/smart-property-lib/static-1.5465",
      "tiered-pricing": "/tiered-pricing/static-1.644",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.518",
      "ui-universal-auth": "/ui-universal-auth/static-1.8539",
      "forms-ai-lib": "/forms-ai-lib/static-1.3807",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2568",
      "stylex": "/stylex/static-1.25",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.13192",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6271",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3367",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5269",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7472",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17545",
      "growth-data-modal": "/growth-data-modal/static-1.5015",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1177",
      "navigation-components": "/navigation-components/static-1.16930",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.173",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7207",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5540",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4773",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3379",
      "commerce-permissions": "/commerce-permissions/static-1.434",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17594",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36198",
      "crm_components": "/crm_components/static-3.90866",
      "crm_data": "/crm_data/static-4.90866",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38471",
      "customer-data-tracking": "/customer-data-tracking/static-1.6546",
      "dispatcher": "/dispatcher/static-1.129",
      "framework-data-table": "/framework-data-table/static-2.11157",
      "property-description-translator": "/property-description-translator/static-1.3544",
      "quartz-head": "/quartz-head/static-1.224",
      "quartz-test": "/quartz-test/static-1.234",
      "csstype": "/csstype/static-1.50",
      "batch-promise": "/batch-promise/static-1.1213",
      "merchandise-lib": "/merchandise-lib/static-1.253",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9525",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "navigation-messaging": "/navigation-messaging/static-1.6257",
      "feature-store-service-types": "/feature-store-service-types/static-1.4213",
      "purchase-motions-components": "/purchase-motions-components/static-1.5310",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4204",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16663",
      "seo-tools-lib": "/seo-tools-lib/static-1.6101",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "bender-build-tools": "/bender-build-tools/static-1.2798",
      "zustand": "/zustand/static-1.51",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3740",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6454",
      "persist-promise": "/persist-promise/static-1.3370",
      "hub-http-janus": "/hub-http-janus/static-1.766",
      "reactive-lib": "/reactive-lib/static-1.412",
      "general-store": "/general-store/static-6.20",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.460",
      "quartz-auth": "/quartz-auth/static-1.234",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21555",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.24",
      "knowledge-content-types": "/knowledge-content-types/static-1.8266",
      "social-insights-client-types": "/social-insights-client-types/static-1.21062",
      "connections-embed-lib": "/connections-embed-lib/static-1.450",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16067",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18660",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.8556",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.12831",
      "property-management-iframe": "/property-management-iframe/static-1.11864",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.6512",
      "hls.js": "/hls.js/static-1.32",
      "js-cookie": "/js-cookie/static-1.18",
      "chatspot-client-types": "/chatspot-client-types/static-1.10322",
      "markdown-it": "/markdown-it/static-1.6",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4416",
      "highcharts": "/highcharts/static-8.97",
      "report-customization-components": "/report-customization-components/static-1.12191",
      "reporting-action-components": "/reporting-action-components/static-1.40393",
      "reporting-data": "/reporting-data/static-1.65996",
      "reporting-snowflake": "/reporting-snowflake/static-1.54615",
      "reporting-visualizations": "/reporting-visualizations/static-1.58073",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.1758",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2077",
      "whisper-core-api": "/whisper-core-api/static-1.5672",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.836",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.12062",
      "html-to-image": "/html-to-image/static-1.47",
      "reporting-plugins": "/reporting-plugins/static-1.9835",
      "reporting-reports": "/reporting-reports/static-1.65675",
      "ui-addon-teams": "/ui-addon-teams/static-1.21067",
      "highlight.js": "/highlight.js/static-1.72",
      "calling-error-reporting": "/calling-error-reporting/static-1.30980",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10702",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6224",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34451",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9560",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8191",
      "directed-graph": "/directed-graph/static-1.621",
      "event-emitter": "/event-emitter/static-1.610",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5148",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9261",
      "fsm": "/fsm/static-1.3416",
      "policy-lib": "/policy-lib/static-1.6487",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9324",
      "academy-common-lib": "/academy-common-lib/static-1.12652",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2682",
      "customer-data-associations": "/customer-data-associations/static-1.7020",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.18172",
      "crm_universal": "/crm_universal/static-1.21473",
      "customer-data-content": "/customer-data-content/static-1.26640",
      "crm_schema": "/crm_schema/static-3.90905",
      "customer-data-email": "/customer-data-email/static-1.17482",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20905",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.649",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12667",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.889",
      "tanstack-virtual": "/tanstack-virtual/static-1.23",
      "customer-data-rte": "/customer-data-rte/static-1.32194",
      "cv-backend-services": "/cv-backend-services/static-1.1446",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5199",
      "qrcode-generator": "/qrcode-generator/static-1.62",
      "quotes-client-types": "/quotes-client-types/static-1.36799",
      "trials-service-types": "/trials-service-types/static-1.3621",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4220",
      "nav-client-types": "/nav-client-types/static-1.2017",
      "purchase-motions-api": "/purchase-motions-api/static-1.5313",
      "signup-constants": "/signup-constants/static-1.18172",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7712",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9176",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17193",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6936",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7181",
      "immutable-less": "/immutable-less/static-1.4336",
      "react-window": "/react-window/static-1.13",
      "ai-studio-lib": "/ai-studio-lib/static-1.10691",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10134",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18616",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7667",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7717",
      "property-management-common": "/property-management-common/static-1.4151",
      "storybook-react": "/storybook-react/static-1.26",
      "trellis-story-utils": "/trellis-story-utils/static-1.4208",
      "dashboard-lib": "/dashboard-lib/static-1.80160",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17287",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8372",
      "reporting-client-types": "/reporting-client-types/static-1.2350",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7926",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34676",
      "sales-views-client-types": "/sales-views-client-types/static-1.3978",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3345",
      "academy-service-client": "/academy-service-client/static-1.3339",
      "utility-belt": "/utility-belt/static-1.2227",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8725",
      "sequences-lib": "/sequences-lib/static-1.7509",
      "deal-intel-utils": "/deal-intel-utils/static-1.893",
      "draft-content-plugins": "/draft-content-plugins/static-1.27464",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.21102",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2902",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3639",
      "stripe-connect-js": "/stripe-connect-js/static-1.62",
      "knowledge-box": "/knowledge-box/static-1.6789",
      "apps-service-types": "/apps-service-types/static-1.3562",
      "oauth-service-types": "/oauth-service-types/static-1.3926",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7383",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14430",
      "crm-component-utils": "/crm-component-utils/static-1.38177",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5555",
      "redux-actions": "/redux-actions/static-3.7",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23717",
      "viral-links-lib": "/viral-links-lib/static-1.6702",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3887",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7366",
      "edison-service-client-types": "/edison-service-client-types/static-1.72",
      "card-properties-lib": "/card-properties-lib/static-1.43202",
      "crm-actions": "/crm-actions/static-1.5955",
      "crm-cards-data": "/crm-cards-data/static-1.1042",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42571",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8505",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3525",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.45120",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14583",
      "crm-fe-perf": "/crm-fe-perf/static-1.22566",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36201",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38621",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10734",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53638",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20600",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16783",
      "project-storage": "/project-storage/static-1.4418",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70712",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5016",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79430",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6523",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53654",
      "commerce-products-api": "/commerce-products-api/static-1.1779",
      "SafeStorage": "/SafeStorage/static-1.4085",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55712",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101387",
      "totals-ui-components": "/totals-ui-components/static-1.22689",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3534"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};